import React, { useEffect, useState } from 'react';
import { getFromApi, postToApi } from '../utilities/NetUtilities';
import { buildUrl } from '../helper/handler';
import { Container, Alert, Table, Modal, Button, Row, Col } from "react-bootstrap";
import LavoratoreForm from './LavoratoreForm';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { SpinnerComp } from '../helper/spinner';
import { sortLavoratori } from '../utilities/CommonUtilities';

function GestioneLavoratori() {

    const [lavoratori, setLavoratori] = useState([]);
    const [message, setMessage] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [currentLavoratore, setCurrentLavoratore] = useState(null);
    const [organizzazione, setOrganizzazione] = useState({});
    const [lavoratoreToDelete, setLavoratoreToDelete] = useState({});
    const [loading, setLoading] = useState(true);
    const [includiInattivi, setIncludiInattivi] = useState(false);
    const [showConflictModal, setShowConflictModal] = useState(false);
    const [conflictData, setConflictData] = useState({});

    const loadLavoratori = (includiInattivi = false) => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const setLavoratoriFromApi = (data) => {
            setLavoratori(sortLavoratori(data.lavoratori));
            setLoading(false);
        };

        if (organizzazioneMap) {
            const params = { 
                organizzazione: organizzazioneMap.nome, 
                tipo: organizzazioneMap.tipo,
                includiInattivi: includiInattivi
            };
            getFromApi(buildUrl('lavoratori', params), setLavoratoriFromApi, setMessageFromApi);
        }
    };

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        if (organizzazioneMap) {
            setOrganizzazione(organizzazioneMap);
            loadLavoratori(includiInattivi);
        }
    }, [includiInattivi]);

    const setMessageFromApi = (data) => {
        setMessage([]);
        data.messaggi.map((value, _) => (
            setMessage(message => [...message, {
                descrizione: value.descrizione,
                tipo: value.tipo.toLowerCase()
            }])
        ));
        setShowModal(false);
        setLoading(false);
    };

    const handleShowModal = (lavoratore) => {
        setMessage([]);
        setCurrentLavoratore(lavoratore);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setCurrentLavoratore(null);
        setShowModal(false);
    };

    const handleShowConfirmModal = (lavoratore) => {
        setMessage([]);
        setLavoratoreToDelete(lavoratore);
        setShowConfirmModal(true);
    };

    const handleCloseConfirmModal = () => {
        setLavoratoreToDelete({});
        setShowConfirmModal(false);
    };

    const handleCloseConflictModal = () => {
        setConflictData({});
        setShowConflictModal(false);
    };

    const handleConfirmActivation = () => {
        // Conferma l'attivazione eliminando i turni conflittuali
        const lavoratoreData = {
            ...currentLavoratore,
            attivo: true,
            tipoOrganizzazione: organizzazione.tipo
        };
        
        const url = buildUrl('confirmLavoratoreActivation');
        postToApi(url, lavoratoreData, action, setMessageFromApi);
        
        setShowConflictModal(false);
        setShowModal(false);
    };

    const action = (data) => {
        console.log('DEBUG Frontend - Response ricevuta:', data);
        setMessage([]);
        
        // Controlla se ci sono conflitti di attivazione
        if (data.requiresConfirmation && data.conflictType === 'LAVORATORE_ACTIVATION_CONFLICT') {
            console.log('DEBUG Frontend - Conflitti rilevati, apertura modal');
            setConflictData(data);
            setShowConflictModal(true);
            return;
        }
        
        console.log('DEBUG Frontend - Nessun conflitto, elaborazione normale');
        
        // Gestione normale dei messaggi
        data.messaggi.forEach((value) => {
            setMessage(prevMessage => [...prevMessage, {
                descrizione: value.descrizione,
                tipo: value.tipo.toLowerCase()
            }]);
        });
        refreshLavoratori(data.lavoratore);
        setShowModal(false);
    };

    const refreshLavoratori = (lavoratore) => {
        if (lavoratore) {
            setLavoratori(prevLavoratori => {
                const existingLavoratoreIndex = prevLavoratori.findIndex(lav => lav.id === lavoratore.id);
                let updatedLavoratori;
                
                // Se il lavoratore è inattivo e il filtro non include inattivi, rimuovilo dalla vista
                if (!lavoratore.attivo && !includiInattivi) {
                    if (existingLavoratoreIndex !== -1) {
                        updatedLavoratori = prevLavoratori.filter(lav => lav.id !== lavoratore.id);
                    } else {
                        updatedLavoratori = prevLavoratori;
                    }
                } else {
                    // Normale aggiornamento
                    if (existingLavoratoreIndex !== -1) {
                        updatedLavoratori = [...prevLavoratori];
                        updatedLavoratori[existingLavoratoreIndex] = lavoratore;
                    } else {
                        updatedLavoratori = [...prevLavoratori, lavoratore];
                    }
                }
                return sortLavoratori(updatedLavoratori);
            });
        }
    };

    const handleSaveLavoratore = (lavoratore) => {
        const lavoratoreUpdated = {
            ...lavoratore
        };
        if (!currentLavoratore) {
            lavoratoreUpdated.organizzazione = organizzazione.nome;
        }
        // Aggiungi sempre il tipo organizzazione per il backend
        lavoratoreUpdated.tipoOrganizzazione = organizzazione.tipo;
        const url = buildUrl(currentLavoratore ? 'editLavoratore' : 'addLavoratore');
        postToApi(url, lavoratoreUpdated, action, setMessageFromApi);
    };

    const okActionDelete = (data) => {
        setLavoratori(prevLavoratori => prevLavoratori.filter(lav => lav.id !== lavoratoreToDelete.id));
        setMessageFromApi(data);
    }

    const handleDeleteLavoratore = () => {
        const url = buildUrl('deleteLavoratore');
        postToApi(url, lavoratoreToDelete, okActionDelete, setMessageFromApi);
        handleCloseConfirmModal();
    };


    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <SpinnerComp />
            </div>
        );
    }

    return (
        <div className='main' role="main">
            <div>
                <h1 className="d-flex justify-content-center inEvidenza" id="title_home">Gestione lavoratori</h1>
                {
                    message && message.map((data, key) => (
                        <Alert variant={data.tipo} id="message" key={key}>
                            {data.descrizione}
                        </Alert>
                    ))
                }
                <Container>
                    <div className="form-check mb-2">
                        <input 
                            className="form-check-input" 
                            type="checkbox" 
                            id="includiinattivi"
                            checked={includiInattivi}
                            onChange={(e) => setIncludiInattivi(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="includiInattivi">
                            Includi lavoratori inattivi
                        </label>
                    </div>
                    <FaPlus id="aggiungi_lavoratore" title='aggiungi lavoratore' className='actionIcon bottom-space-ridotto' onClick={() => handleShowModal(null)} />
                    {lavoratori.length > 0 ? (
                        <Table id="tabella_lavoratori" striped bordered hover>
                            <thead>
                                <tr>
                                    <th className="inEvidenza App">nome</th>
                                    <th className="inEvidenza App">cognome</th>
                                    <th className="inEvidenza App">email</th>
                                    <th className="inEvidenza App">lunedì</th>
                                    <th className="inEvidenza App">martedì</th>
                                    <th className="inEvidenza App">mercoledì</th>
                                    <th className="inEvidenza App">giovedì</th>
                                    <th className="inEvidenza App">venerdì</th>
                                    <th className="inEvidenza App">sabato</th>
                                    <th className="inEvidenza App">ore settimanali</th>
                                    <th className="inEvidenza App">stato</th>
                                    <th className="inEvidenza App">azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lavoratori.map((lavoratore, index) => (
                                    <tr key={lavoratore.id}>
                                        <td>{lavoratore.nome}</td>
                                        <td>{lavoratore.cognome}</td>
                                        <td>{lavoratore.email}</td>
                                        <td className="number">{lavoratore.mapOrePerGiorno.lunedì}</td>
                                        <td className="number">{lavoratore.mapOrePerGiorno.martedì}</td>
                                        <td className="number">{lavoratore.mapOrePerGiorno.mercoledì}</td>
                                        <td className="number">{lavoratore.mapOrePerGiorno.giovedì}</td>
                                        <td className="number">{lavoratore.mapOrePerGiorno.venerdì}</td>
                                        <td className="number">{lavoratore.mapOrePerGiorno.sabato}</td>
                                        <td className="number">{lavoratore.totaleOreSettimana}</td>
                                        <td className={lavoratore.attivo !== false ? 'text-success' : 'text-danger'}>
                                            {lavoratore.attivo !== false ? 'Attivo' : 'Inattivo'}
                                        </td>
                                        <td>
                                            <div className="actionIconContainer">
                                                <FaEdit title='modifica lavoratore' id={`edit-lavoratore-${index}`} className='actionIcon' onClick={() => handleShowModal(lavoratore)} />
                                                <FaTrash title='elimina lavoratore' id={`delete-lavoratore-${index}`} className='actionIcon' onClick={() => handleShowConfirmModal(lavoratore)} />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <Row className="justify-content-center">
                            <Col xs={12} className="text-center">
                                <p>Non ci sono lavoratori.</p>
                            </Col>
                        </Row>
                    )}
                    <FaPlus className='actionIcon' onClick={() => handleShowModal(null)} />
                </Container>
            </div>
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title id="title_popup">{currentLavoratore ? 'Modifica Lavoratore' : 'Aggiungi Lavoratore'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <LavoratoreForm lavoratore={currentLavoratore} onSave={handleSaveLavoratore} onClose={handleCloseModal} />
                </Modal.Body>
            </Modal>

            <Modal show={showConfirmModal} onHide={handleCloseConfirmModal}>
                <Modal.Header closeButton>
                    <Modal.Title id="title_popup">Conferma Eliminazione</Modal.Title>
                </Modal.Header>
                <Modal.Body>Sei sicuro di voler eliminare il lavoratore '{lavoratoreToDelete.nome + " " + lavoratoreToDelete.cognome}' ?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" id="annulla_elimina" onClick={handleCloseConfirmModal}>
                        Annulla
                    </Button>
                    <Button variant="danger" id="elimina" onClick={handleDeleteLavoratore}>
                        Elimina
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showConflictModal} onHide={handleCloseConflictModal}>
                <Modal.Header closeButton>
                    <Modal.Title id="title_popup">Conflitti Attivazione Lavoratore</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <strong>Attenzione!</strong> L'attivazione del lavoratore <strong>{conflictData.nomeCognomeLavoratore}</strong> genera conflitti con i turni esistenti.
                    </div>
                    {conflictData.conflictMessages && conflictData.conflictMessages.length > 0 && (
                        <div className="mb-3">
                            <strong>Dettagli conflitti:</strong>
                            <ul>
                                {conflictData.conflictMessages.map((message, index) => (
                                    <li key={index}>{message}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="mb-3">
                        Procedendo, tutti i turni conflittuali del lavoratore <strong>{conflictData.nomeCognomeLavoratore}</strong> verranno eliminati automaticamente. Questa azione non può essere annullata.
                    </div>
                    <div>
                        <strong>Vuoi procedere con l'attivazione?</strong>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" id="annulla_conflitto" onClick={handleCloseConflictModal}>
                        Annulla
                    </Button>
                    <Button variant="warning" id="conferma_conflitto" onClick={handleConfirmActivation}>
                        Procedi con Attivazione
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default GestioneLavoratori;
